import api from './api';

const mobileAccessService = {
  getPracticeMobileAccess: async (practiceId) => {
    const response = await api.get(`/practices/${practiceId}/mobile-access`);
    return response;
  },

  updatePracticeMobileAccess: async (practiceId, userIds) => {
    const response = await api.put(`/practices/${practiceId}/mobile-access`, {
      user_ids: userIds
    });
    return response;
  }
};

export default mobileAccessService;
